import { cleanObject } from '@shared/utils';
import getPieveCompanyIdForRequest from '@/lib/auth/getPieveCompanyIdForRequest.js';
import { get, post, put } from '@/redux/requests/api.js';

export const listTriggers = ({ limit = 200, offset = 0, q = null, active = null, triggerType = null, sortBy = 'updatedAt', sortDirection = 'desc', includeArchived = null, includeTotal = true } = {}, callback) => {
  const companyId = String(getPieveCompanyIdForRequest() || '').trim() || null;

  return get('/v1/pieve/triggers', {
    action: 'GET_TRIGGERS',
    loader: 'getTriggers',
    callback,
    meta: {
      companyId
    },
    query: cleanObject(
      {
        limit,
        offset,
        q,
        active,
        triggerType,
        sortBy,
        sortDirection,
        includeArchived,
        includeTotal
      },
      { strict: true }
    )
  });
};

export const updateTrigger = ({ triggerId, title, prompt, active, composerModel, composerReasoningEffort, triggerSummary, triggerConfig, allowStaleWrite = undefined, expectedUpdatedAt = undefined } = {}, callback) => {
  const normalizedTriggerId = String(triggerId || '').trim();

  return put(`/v1/pieve/triggers/${encodeURIComponent(normalizedTriggerId)}`, {
    action: 'UPDATE_TRIGGER',
    loader: 'updateTrigger',
    callback,
    data: cleanObject(
      {
        title,
        prompt,
        active,
        composerModel,
        composerReasoningEffort,
        triggerSummary,
        triggerConfig,
        allowStaleWrite,
        expectedUpdatedAt
      },
      { strict: true }
    )
  });
};

export const getTriggerRunList = ({ triggerId, startDate = undefined, endDate = undefined, timezone = undefined } = {}, callback) => {
  const normalizedTriggerId = String(triggerId || '').trim();

  return get(`/v1/pieve/triggers/${encodeURIComponent(normalizedTriggerId)}/runs`, {
    action: 'GET_TRIGGER_RUN_LIST',
    loader: 'getTriggerRunList',
    callback,
    query: cleanObject(
      {
        startDate,
        endDate,
        timezone
      },
      { strict: true }
    )
  });
};

export const getTriggerRunDailyCounts = ({ triggerId, startDate = undefined, endDate = undefined, timezone = undefined } = {}, callback) => {
  const normalizedTriggerId = String(triggerId || '').trim();

  return get(`/v1/pieve/triggers/${encodeURIComponent(normalizedTriggerId)}/runs/daily-counts`, {
    action: 'GET_TRIGGER_RUN_DAILY_COUNTS',
    loader: 'getTriggerRunDailyCounts',
    callback,
    query: cleanObject(
      {
        startDate,
        endDate,
        timezone
      },
      { strict: true }
    )
  });
};

export const getTriggerOperations = ({ triggerId, startDate = undefined, endDate = undefined, timezone = undefined } = {}, callback) => {
  const normalizedTriggerId = String(triggerId || '').trim();

  return get(`/v1/pieve/triggers/${encodeURIComponent(normalizedTriggerId)}/operations`, {
    action: 'GET_TRIGGER_OPERATIONS',
    loader: 'getTriggerOperations',
    callback,
    query: cleanObject(
      {
        startDate,
        endDate,
        timezone
      },
      { strict: true }
    )
  });
};

export const getTriggerRecentActivityChartDailyCounts = ({ triggerId, startDate = undefined, endDate = undefined, timezone = undefined } = {}, callback) => {
  const normalizedTriggerId = String(triggerId || '').trim();

  return get(`/v1/pieve/triggers/${encodeURIComponent(normalizedTriggerId)}/operations/daily-counts`, {
    action: 'GET_TRIGGER_RECENT_ACTIVITY_CHART_DAILY_COUNTS',
    loader: 'getTriggerRecentActivityChartDailyCounts',
    callback,
    query: cleanObject(
      {
        startDate,
        endDate,
        timezone
      },
      { strict: true }
    )
  });
};

export const getTriggerPolls = ({ triggerId } = {}, callback) => {
  const normalizedTriggerId = String(triggerId || '').trim();

  return get(`/v1/pieve/triggers/${encodeURIComponent(normalizedTriggerId)}/polls`, {
    action: 'GET_TRIGGER_POLLS',
    loader: 'getTriggerPolls',
    callback
  });
};

export const dispatchTrigger = ({ triggerId } = {}, callback) => {
  const normalizedTriggerId = String(triggerId || '').trim();

  return post(`/v1/pieve/triggers/${encodeURIComponent(normalizedTriggerId)}/dispatch`, {
    action: 'DISPATCH_TRIGGER',
    loader: 'dispatchTrigger',
    eventKey: 'triggerRun',
    callback,
    data: {}
  });
};
